import React, { memo } from 'react';
import Animated, { interpolateColor, useAnimatedStyle, } from 'react-native-reanimated';
import { StyleSheet, View } from 'react-native';
import SearchBar from 'design-system/SearchBar';
import { NavigationHeader, rem } from 'design-system';
import SelectorControllableReanimated from 'design-system/SelectorControllableReanimated';
import useColors from 'hooks/useColors';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useIsMainAppWalkthroughV6Active } from 'features/feed/components/walkthrough/hooks/useIsMainAppWalkthroughV6Active';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { isWeb } from '../../../../constants';
const LearnHeader = ({ scrollY, scrollX, sections, onCancel, searchTerm, isSearching, screenWidth, setSelection, containerStyle, onChangeSearchTerm, categoriesScrollViewRef, }) => {
    const colors = useColors();
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const enableScroll = sections.length > 2;
    const isMainWalkthroughV6Active = useIsMainAppWalkthroughV6Active();
    const textInputStyle = useAnimatedStyle(() => ({
        backgroundColor: interpolateColor(scrollY.value, [0, 40], [
            colors.cards.onDark,
            colors.background.dark,
        ]),
    }), [colors, scrollY]);
    return (<View>
      <NavigationHeader title="Learn" scrollY={scrollY} isWalkthroughActive={isMainWalkthroughV6Active} rightContent={isWeb || isMainWalkthroughV6Active ? null : <HelpScreenButton />}>
        <View style={paddingHorizontalStyle}>
          <SearchBar placeholder="Search" onCancel={onCancel} onChangeSearchTerm={onChangeSearchTerm} textInputBgStyles={textInputStyle}/>
        </View>
        {!searchTerm && !isSearching ? (<Animated.ScrollView horizontal style={styles.container} ref={categoriesScrollViewRef} showsHorizontalScrollIndicator={false} scrollEnabled={enableScroll} contentContainerStyle={containerStyle}>
            <SelectorControllableReanimated scrollX={scrollX} sections={sections} screenWidth={screenWidth} setSelection={setSelection} selectorStyle={styles.selectorStyle} itemContainerStyle={styles.itemContainerStyle}/>
          </Animated.ScrollView>) : null}
      </NavigationHeader>
    </View>);
};
export default memo(LearnHeader);
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        paddingBottom: rem(12),
        paddingTop: rem(8),
    },
    itemContainerStyle: {
        padding: 0,
        margin: 0,
    },
    selectorStyle: {
        borderRadius: rem(8),
        justifyContent: 'center',
        padding: 0,
        margin: 0,
    },
});
